import React, { useEffect, useState } from "react";
import "survey-core/defaultV2.min.css";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//react component start with capital letter
export default function Surveypage() {
  const id = window.location.pathname.replace("/", "");

  //TODO when the survey is done and it's submitted replace the whole page with a new html page will be loaded to say thank you
  const [message, setMessage] = useState(null);

  function handleResult(result) {
    //Inside the function, there's a switch statement based on the value of result.next_step.
    //This is a way to handle different cases or scenarios based on the value of next_step.
    switch (result.next_step) {
      //Case "redirect": If result.next_step is "redirect"
      //it means that the operation requires a redirection to another URL.
      case "redirect": {
        const text = "[Redirecting to another page.] " + result.message;
        toast.success(text);
        setMessage({ status: "success", text });
        setTimeout(() => {
          window.location.href = result.redirect_to; // Change to the actual URL
        }, 1000);
        //handle redirect
        break;
      }
      //Case "show_success_message": If result.next_step is "show_success_message",
      //it means that the operation was successful, and the code calls the function showMessage
      //with the arguments 'success' and 'Operation was successful!'
      case "show_success_message": {
        const text = "[Operation was successful!] " + result.message;
        toast.success(text);
        setMessage({ status: "success", text });
        //show the message 'success'
        break;
      }
      //Case "show_error_message": If result.next_step is "show_error_message",
      //it means that an error occurred during the operation. Similar to the previous case,
      //the code calls the function showMessage with the arguments 'error' and 'An error occurred.'.
      case "show_error_message": {
        const text = "[An error occurred.] " + result.message;
        toast.error(text);
        setMessage({ status: "error", text });
        break;
      }
      case "next_survey": {
        const text = "[Redirecting to another survey.] " + result.message;
        toast.success(text);
        document.title = result.survey_data.title || "Boomerang Survey";
        document
          .querySelector('meta[name="description"]')
          .setAttribute("content", result.survey_data.description);
        const s = new Model({
          ...result.survey_data,
          logo: result.logo,
        });
        //we applied theme to survey
        s.applyTheme(result.theme);
        s.onComplete.add(surveyComplete);
        //set the state variable
        setSurvey(s);
        break;
      }
      default:
      //show message 'error'
    }
  }
  // Define an asynchronous function named postSurveyJson that takes 'data' as a parameter
  async function postSurveyJson(id, data) {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

    try {
      // Use the 'fetch' function to make an HTTP POST request to the specified URL
      const response = await fetch("/surveyData/" + id + "?tz=" + tz, {
        method: "POST", // or 'PUT'
        headers: {
          "Content-Type": "application/json", // Set the content type to JSON
          Authorization: token,
        },
        body: JSON.stringify(data), // Convert 'data' to a JSON string and set it as the request body
      });
      // At this point, the POST request has been sent and a response has been received
      // The response object contains information about the response from the server
      // You can process the response here (not shown in the provided code snippet)
      const result = await response.json();
      if (response.status === 200) {
        handleResult(result);
      } else {
        toast.error(result.message);
        setMessage({ status: "error", text: result.message });
      }
    } catch (error) {
      // If an error occurs during the fetch or request handling, it will be caught here
      toast.error("There was a problem");
      setMessage({ status: "error", text: "There was a problem" });
      console.error("Error:", error);
    }
  }

  //create survey variable when it runs it's empty
  //this is state variable named survey and setSurvey is the fucntion that define the state variable
  const [survey, setSurvey] = useState();

  const surveyComplete = (sender) => {
    const files = {};
    //add a function to send this back to the server
    const resultData = {};
    for (const key in sender.data) {
      const question = sender.getQuestionByName(key);
      if (!question) {
        continue;
      }
      const questionType = question.getType();
      if (typeof question.value === "object") {
        if (questionType === "file") {
          files[key] = question.value;
        } else {
          resultData[key] = question.value;
        }
      } else {
        if (questionType === "signaturepad") {
          // signature is a file
          // but survey returns it as text response
          files[key] = [
            {
              content: question.value,
              name: "signature_" + key + "_" + Date.now() + ".png",
              type: "image/png",
            },
          ];
        } else {
          resultData[key] = [question.value.toString()];
        }
      }
    }
    postSurveyJson(window.location.pathname.replace("/", ""), {
      resultData,
      files,
    });
    // console.log(sender, sender.data)
  };
  //get data from server
  async function getSurveyData(id) {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const response = await fetch("/surveyData/" + id + "?tz=" + tz, {
        method: "GET",
        headers: {
          Authorization: token,
        },
      });
      const data = await response.json();

      if (response.status === 200) {
        //geetting data from server (survey variable)
        if (data.survey_data) {
          document.title = data.survey_data.title || "Boomerang Survey";
          document
            .querySelector('meta[name="description"]')
            .setAttribute("content", data.survey_data.description);
          const s = new Model({
            ...data.survey_data,
            logo: data.logo,
          });
          //we applied theme to survey
          s.applyTheme(data.theme);
          s.onComplete.add(surveyComplete);
          //set the state variable
          setSurvey(s);
        }
        if (data.next_step === "show_error_message") {
          setMessage({ status: "error", text: data.message });
        }
      } else {
        toast.error(data.message);
        setMessage({ status: "error", text: data.message });
      }
    } catch (error) {
      toast.error("An error occurred.", error);
    }
  }

  const [token, setToken] = useState(null);
  //runs once only the initial data
  useEffect(() => {
    if (token) {
      getSurveyData(id);
    }
  }, [token]);

  const getToken = (surveyId) =>
    fetch("/token/" + surveyId)
      .then((res) => res.json())
      .then((data) => setToken(data));

  useEffect(() => {
    if (id) {
      getToken(id);
    }
  }, [id]);

  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      {message && <div className={message?.status}>{message?.text}</div>}
      {survey ? (
        <Survey className="height-fix" model={survey} />
      ) : (
        <div className="height-fix" />
      )}
      <footer className="page-copyright">
        <p>
          <strong>Boomerang Messaging Services</strong> &copy; 2010 - 2023
          Boomerang I-comms Ltd, trading as Boomerang. Registered in England
          &amp; Wales number 08217876. ISO27001 certified
        </p>
        <a
          href="https://boomerangmessaging.com/privacy-policy/"
          target="_blank"
        >
          Privacy Policy
        </a>{" "}
        |{" "}
        <a href="https://boomerangmessaging.com/cookie-policy/" target="_blank">
          Cookie Policy
        </a>
      </footer>
      <ToastContainer />
    </div>
  );
}
